import { Timestamps } from '@/core/types/shared'
import { StaffType } from '@/utils/onboarding/type'
import { Document } from './document.model'
import { Order } from './order.model'
import { Staff } from './staff.model'

export type ActConditionType = 'always' | 'time' | 'patient_age'

export interface ActCondition {
  type: ActConditionType
  after?: string    // HH:mm 24h
  before?: string   // HH:mm 24h
  minAge?: number
  maxAge?: number
}

export interface WaitingRoomActConfig {
  actId: string
  establishmentId: string
  role: StaffType
  autoCreateDesmos: boolean
  autoCreateFSP: boolean
  conditions: ActCondition[]
  waitingRooms: string[]
}

// Legacy type kept for backward compat during migration
export interface NetworkDesmosAct {
  actId: string
  autoCreate: boolean
  waitingRooms?: string[]
  establishmentId?: string
}

export type Network = Timestamps & {
  _id: string
  coverPhoto?: Pick<Document, 'filename' | 'key' | 'url'>
  createdBy: Pick<Staff, '_id' | 'accountType' | 'userInfo'>
  description?: string
  members: string[]
  name: string
  chatRoom?: string
  pendingMembers: Pick<Staff, '_id' | 'accountType' | 'userInfo'>[]
  pendingOrders: Order[]
  privacy: 'public' | 'private'
  desmosActs?: NetworkDesmosAct[];
  waitingRoomActConfigs?: WaitingRoomActConfig[];
}

export type NetworkInvitation = Timestamps & {
  _id: string
  inviter: Pick<Staff, '_id' | 'accountType' | 'userInfo'>
  invitee: string
  network: Network
}

export type NetworkMember = {
  _id: string
  accessLevel: NetworkMemberAccessLevel
  member: Pick<Staff, '_id' | 'accountType' | 'email' | 'establishment' | 'speciality' | 'status' | 'userInfo'>
  invitedBy?: Pick<Staff, '_id' | 'accountType' | 'email' | 'userInfo'>
  network: string
  notificationPreferences?: NetworkNotificationPreferences
  notificationFrequences?: NetworkNotificationFrequences
}

export enum NetworkMemberAccessLevel {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export enum NetworkNotificationPreferences {
  ALL = 'ALL',
  ONLY_CONSULTATION = 'ONLY_CONSULTATION',
  ONLY_EXPERTISE = 'ONLY_EXPERTISE',
}

export enum NetworkNotificationFrequences {
  IMMEDIATE = 'immediate',
  DAILY = 'daily',
  NEVER = 'never',
}
